/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Row} from "react-bootstrap";

import {AiFillPhone} from "react-icons/all";


interface CONTACT_REASONS_INTERFACE {
    Order: number;
    Text: string;
}


interface CONTACT_TYPE_INTERFACE {
    Type: "M" | "P",
    Address: string,
    Reasons?: CONTACT_REASONS_INTERFACE[]
}


type ContactPageProps = {contactData: CONTACT_TYPE_INTERFACE};


export const ContactPagePhoneComponent: React.FC<ContactPageProps> = ({contactData = null}): JSX.Element | null => {


    if (!contactData) return null;


    const {Address: contactPhoneNumber} = contactData;


    return (
        <Col xs={12} className={"contact-page-phone-component contact-page-contact-component"}>
            <Row className={"contact-page-phone-content"}>

                <Col xs={12} className={"contact-page-contact-header"}>
                    <AiFillPhone />
                    <span>{`Infolinia`}</span>
                </Col>

                <Col xs={12} className={"contact-page-contact-address"}>
                    <a href={`tel:${contactPhoneNumber.replaceAll(" ", "")}`} title={`Zadzwoń do nas`}>
                        <span className={"contact-address-value"}>{contactPhoneNumber}</span>
                        <span className={"contact-address-icon"}>
                            <AiFillPhone />
                        </span>
                    </a>
                </Col>

                <Col xs={12} className={"contact-page-contact-label"}>
                    <span>{`Koszt połączeń według cennika operatora`}</span>
                </Col>

            </Row>
        </Col>
    );

};


export default ContactPagePhoneComponent;
